import { Button } from '@heroui/react';

// Φόρτωση επόμενης σελίδας, με προσάρτηση.
//
// **Δεν χρησιμοποιείται πλέον στους δύο μεγάλους καταλόγους.** Οι συλλογές και
// οι πόροι σελιδοποιούνται με αριθμούς (`Pagination.jsx`, ΜΛΑ-06), γιατί το
// κουμπί δεν κλιμακώνεται: με 500 πόρους απαιτεί 25 πατήματα ως το τέλος και
// δεν δίνει διεύθυνση στη σελίδα 12.
//
// Παραμένει γιατί ταιριάζει σε **κοντούς καταλόγους που δεν φιλτράρονται** —
// σχόλια κάτω από πόρο, σημειώσεις καθήκοντος — όπου η αρίθμηση θα ήταν
// βαρύτερη από το περιεχόμενο. Τα P1-3 και P1-4 το βρίσκουν έτοιμο.

/** Πόσα φαίνονται από πόσα, και το κουμπί για τα επόμενα. */
export function LoadMore({ loaded, meta, isLoading, onLoadMore, noun = 'εγγραφές' }) {
    if (!meta) return null;

    const hasMore = meta.page < meta.totalPages;
    if (!hasMore && loaded >= meta.total) return null;

    return (
        <div className="flex flex-col items-center gap-2 py-4">
            <p className="text-sm text-muted" aria-live="polite">
                {loaded} από {meta.total} {noun}
            </p>
            {hasMore && (
                <Button variant="outline" isPending={isLoading} onPress={onLoadMore}>
                    <i className="fa-solid fa-chevron-down" aria-hidden="true" />
                    Φόρτωση περισσότερων
                </Button>
            )}
        </div>
    );
}

/**
 * Το μήνυμα όταν η αναζήτηση δεν βρίσκει τίποτα.
 *
 * **Απλοποιήθηκε στο P1-5, και η απλοποίηση είναι το αποτέλεσμα και όχι ο
 * σκοπός.** Οι τρεις καταστάσεις έγιναν δύο επειδή η τρίτη **έπαψε να
 * υπάρχει**: όσο το φιλτράρισμα γινόταν στον πελάτη, αφορούσε μόνο τα
 * φορτωμένα, οπότε ένα σκέτο «καμία αντιστοιχία» βεβαίωνε ανυπαρξία για κάτι
 * που μπορεί να ζούσε στη σελίδα 3 — ψευδής ισχυρισμός (ΜΛΑ-03). Το μήνυμα
 * δήλωνε τότε το πραγματικό εύρος του ελέγχου.
 *
 * Με την αναζήτηση στον διακομιστή, το εύρος του ελέγχου **ταυτίζεται** με το
 * εύρος του ισχυρισμού, και το «καμία αντιστοιχία» γίνεται αληθές. Το
 * `hasMore` δεν χρειάζεται πλέον και αφαιρέθηκε.
 */
export function EmptyResult({ isSearching, emptyMessage }) {
    if (!isSearching) return <p className="py-16 text-center text-muted">{emptyMessage}</p>;

    return <p className="py-16 text-center text-muted">Καμία αντιστοιχία.</p>;
}

export default LoadMore;
